export default "__VITE_ASSET__DbHIQ_nK__"